import { render, staticRenderFns } from "./FeedbacksCard.vue?vue&type=template&id=fe2af81c"
import script from "./FeedbacksCard.vue?vue&type=script&lang=js"
export * from "./FeedbacksCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports